import React from 'react';

interface EduProgressBarProps {
  progress: number; // 0 to 100
  label?: string;
  sublabel?: string;
  showPercentage?: boolean;
  status?: 'normal' | 'success' | 'error' | 'warning';
}

export const EduProgressBar: React.FC<EduProgressBarProps> = ({
  progress,
  label,
  sublabel,
  showPercentage = true,
  status = 'normal',
}) => {
  const clampedProgress = Math.min(100, Math.max(0, progress));

  const barColors = {
    normal: 'bg-brand-primary',
    success: 'bg-status-success',
    error: 'bg-status-error',
    warning: 'bg-status-warning',
  };

  return (
    <div className="w-full">
      {(label || showPercentage) && (
        <div className="flex justify-between items-center text-xs mb-1.5 font-medium">
          <span className="text-txt-primary">{label}</span>
          {showPercentage && (
            <span className="text-txt-secondary font-semibold">
              {clampedProgress}%
            </span>
          )}
        </div>
      )}
      <div className="w-full bg-slate-100 rounded-full h-2.5 overflow-hidden border border-slate-200">
        <div
          className={`h-full transition-all duration-300 rounded-full ${barColors[status]}`}
          style={{ width: `${clampedProgress}%` }}
        ></div>
      </div>
      {sublabel && (
        <p className="text-xs text-txt-muted mt-1">{sublabel}</p>
      )}
    </div>
  );
};
